<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DatePickerGrid, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerGrid :class="cn('w-full border-collapse space-y-1', props.class)" v-bind="forwardedProps">
        <slot />
    </DatePickerGrid>
</template>
